export const HOME = '/';
export const CONTACT = '/contact-us';
export const ABOUT = '/about';
export const SERVICEDETAIL = '/services/:slug';
export const CASEDETAIL = '/case-studies/:slug';